import { render, staticRenderFns } from "./NovaSearch.vue?vue&type=template&id=b77da08e&scoped=true"
import script from "./NovaSearch.vue?vue&type=script&lang=js"
export * from "./NovaSearch.vue?vue&type=script&lang=js"
import style0 from "./NovaSearch.vue?vue&type=style&index=0&id=b77da08e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b77da08e",
  null
  
)

export default component.exports